/**
 * @module views\aps\order
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Order extends Vue {
  private module = "";

  private isShow = false;

  private test() {
    
  }
}
